import { LOG_OUT_USER, UPDATE_AUTHORIZED, VERIFY_TOKEN } from "../../actions/actionTypes";

const authorizationReducer = (state=false, action) => {
    let  authorized = state;
    
    switch(action.type){ 
        case UPDATE_AUTHORIZED:
            return action.payload;
        case VERIFY_TOKEN:
            return action.payload;
        case LOG_OUT_USER:
            return false;
        default:
            if(
                Array.isArray(action.errors) && 
                action.errors.length > 0 && 
                'message'in action.errors[0] && 
                action.errors[0]["message"] == "You must be logged in to perform this action"
            ){
                return false;
            }else{
                return authorized;
            }
    }
    
};

export default authorizationReducer;